<template>
  <div id="navbar">
    <!-- Logo -->
    <div class="wrap-left">
      <img
        src="@/assets/logo/logo-studio.svg"
        height="30"
      >
    </div>

    <!-- Profile -->
    <div class="wrap-profile">
      <!-- Icon Help -->
      <img
        :src="require(`@/assets/icon/help-${showContentHelp ? 'blue' : 'gray'}.svg`)"
        width="20"
        alt="type-help"
        class="cursor-pointer m__r--16"
        @click="showContentHelp = !showContentHelp" >

      <div
        v-click-outside="hideDropdown"
        class="profile"
        @click="showDropdown = !showDropdown"
      >
        <!-- If have profile pic -->
        <img
          v-if="profile_data && profile_data.photo_url"
          :src="profile_data.photo_url"
          alt="profile-pic-small"
        >

        <!-- Create initial name if dont have initial name -->
        <div
          v-else
          :style="`background-color: ${bg_initial_profile}`"
          class="initial"
        >
          {{ initialName }}
        </div>

        <i class="fa fa-sort-desc" />
      </div>
    </div>

    <!-- Dropdown Profile -->
    <div
      v-if="showDropdown"
      class="dropdown-profile"
    >
      <!-- If have profile pic -->
      <img
        v-if="profile_data && profile_data.photo_url"
        :src="profile_data.photo_url"
        alt="profile-pic-small"
      >

      <!-- Create initial name if dont have initial name -->
      <div
        v-else
        :style="`background-color: ${bg_initial_profile}`"
        class="initial"
      >
        {{ initialName }}
      </div>

      <p class="profile-name">
        {{ fullName }}
      </p>
      <p class="profile-email">
        {{ profile_data.email }}
      </p>

      <div
        class="section-button">
        <button
          class="button"
          @click="handleLogout"
        >
          Logout
        </button>
      </div>
    </div>

    <!-- Content Help -->
    <div
      v-click-outside="hideContentHelp"
      v-if="showContentHelp"
      class="content-help" >
      <div class="content-help-header">
        <h4> Help & Documentation </h4>
        <div
          class="close-properties"
          @click="hideContentHelp" >
          &times;
        </div>

        <img
          v-if="!isOpenDetailModule"
          :src="require('@/assets/icon/search-page.svg')"
          class="img-search">
        <input
          v-if="!isOpenDetailModule"
          v-model="search"
          type="text"
          class="input-search"
          placeholder="Search"
          @keypress.13.prevent="filterDocument"
        >
      </div>

      <div
        v-if="!isOpenDetailModule && !isOpenSearchModule"
        class="content-help-body">
        <div class="module-content">
          <label>Categorize by Module</label>
          <div
            v-if="!loading_module"
            class="wrap-module">
            <div
              v-for="(item, index) in list_module"
              :key="index"
              class="list-module"
              @click="openDetailModule(item)">
              <img
                :src="item.logo"
                width="35"
                height="35"
                class="m__t--7" >
              <div class="title">{{ item.name }}</div>
            </div>
          </div>
          <div
            v-else
            class="wrap-module">
            <div
              v-for="i in 6"
              :key="i"
              class="skeleton"
            />
          </div>
        </div>

        <div class="featured-topic">
          <label>Featured Topic</label>
          <div v-if="!loading_featured">
            <div
              v-for="(item, index) in list_featured"
              :key="index"
              class="list-featured">
              <div class="d-flex">
                <img
                  :src="item.logo"
                  width="20"
                  height="20"
                  class="m__r--10" >
                <div class="title">{{ item.name }}</div>
              </div>

              <div v-if="item.documents">
                <div
                  v-for="(itemDoc, indexDoc) in item.documents"
                  :key="indexDoc"
                  class="list-document"
                  @click="directToDocsFeatured(item, itemDoc)">
                  <img
                    :src="require('@/assets/icon/list-document.svg')"
                    width="17"
                    class="m__r--10" >
                  <div class="title-featured">{{ itemDoc.title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="i in 2"
            v-else
            :key="i"
            class="skeleton"
          />
        </div>
      </div>

      <div
        v-if="isOpenDetailModule && !isOpenSearchModule"
        class="content-help-body">
        <div class="detail-module">
          <img
            class="back-to-list"
            src="@/assets/icon/arrow-left.svg"
            @click="backToModule"
          >
          <img
            :src="moduleSelected.logo"
            width="17"
            height="17"
            class="m__r--10" >
          <div class="title">{{ moduleSelected.name }}</div>
        </div>
        <div v-if="!loading_document">
          <div
            v-for="(item, index) in list_document"
            :key="index"
            class="list-document"
            @click="directToDocs(item)">
            <img
              :src="require('@/assets/icon/list-document.svg')"
              width="17"
              class="m__r--10" >
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
        <div
          v-else
          class="m__t--15">
          <div
            v-for="i in 4"
            :key="i"
            class="skeleton"
          />
        </div>
      </div>

      <div
        v-if="!isOpenDetailModule && isOpenSearchModule"
        class="content-help-body">
        <div v-if="!loading_document_by_search">
          <div class="count-result">{{ count_list_document_by_search }} results</div>
          <div
            v-for="(item, index) in list_document_by_search"
            :key="index"
            class="list-document border-bottom"
            @click="directToDocsBySearch(item)">
            <div>
              <img
                :src="require('@/assets/icon/list-document.svg')"
                width="17"
                class="m__r--10" >
            </div>
            <div>
              <div class="title-by-search">{{ item.title }}</div>
              <div
                class="title"
                v-html="decodeHtmlEntities(item)" />
            </div>
          </div>
        </div>
        <div
          v-else
          class="m__t--15">
          <div
            v-for="i in 4"
            :key="i"
            class="skeleton"
          />
        </div>
      </div>

      <div class="content-help-footer">
        <img
          :src="require('@/assets/icon/forum.svg')"
          width="33"
          class="m__r--10" >
        <div>
          <div class="title">Officeless Forum</div>
          <div class="desc">
            Enjoy your new forum! Hop over to <b>forum.jojonomic.com</b>,
            if you have any questions, or to join our community.
          </div>
        </div>
        <img
          :src="require('@/assets/automation/open-tab.svg')"
          width="12"
          class="open-tab"
          @click="openForum" >
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console */
import { mapActions, mapMutations, mapState } from 'vuex';
import ClickOutside from 'vue-click-outside';
import axios from 'axios';
import Vue from 'vue';
import he from 'he';

export default {
  directives: {
    ClickOutside,
  },

  data() {
    return {
      showDropdown: false,
      showContentHelp: false,

      search: null,
      list_featured: [],
      list_module: [],
      list_document: [],
      list_document_by_search: [],
      loading_featured: true,
      loading_module: true,
      loading_document: true,
      loading_document_by_search: true,
      isOpenDetailModule: false,
      moduleSelected: null,
      isOpenSearchModule: false,
      count_list_document_by_search: 0,
    };
  },

  computed: {
    ...mapState('jStoreLogin', ['profile_data', 'bg_initial_profile']),

    // eslint-disable-next-line consistent-return
    fullName() {
      if (this.profile_data) {
        return `${this.profile_data.first_name} ${this.profile_data.last_name}`;
      }
    },

    // eslint-disable-next-line consistent-return
    initialName() {
      if (this.profile_data) {
        return this.createInitialName(this.fullName);
      }
    },
  },

  watch: {
    showContentHelp(val) {
      if (val) {
        this.getModule();
      }
    },

    search(val) {
      if (!val) {
        this.isOpenSearchModule = false;
        this.loading_document_by_search = true;
        this.list_document_by_search = [];
        this.count_list_document_by_search = 0;
      }
    },
  },

  created() {
    this.setBgInitialProfile();
  },

  methods: {
    ...mapActions('jStoreLogout', ['logoutAccount']),
    ...mapMutations('jStoreLogin', ['setBgInitialProfile']),

    createInitialName(name) {
      return name.match(/(\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('')
        .toUpperCase();
    },

    hideDropdown() {
      this.showDropdown = false;
    },

    hideContentHelp() {
      this.showContentHelp = false;
      this.loading_featured = true;
      this.loading_module = true;
      this.list_featured = [];
      this.list_module = [];
      this.isOpenSearchModule = false;
      this.loading_document_by_search = true;
      this.list_document_by_search = [];
      this.count_list_document_by_search = 0;
      this.isOpenDetailModule = false;
      this.moduleSelected = null;
      this.loading_document = true;
      this.list_document = [];
      this.search = null;
    },

    openForum() {
      window.open('https://forum.jojonomic.com/', '_blank');
    },

    getModule() {
      const url = 'https://gateway.jojonomic.com/v2/lowcodeapp/14/officeless-docs/documentation/get-module?is_featured=true';
      const token = Vue.ls.get('Token');

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Apikey: 'fe63da93-60e7-4b42-b01b-e0b4c5abab47',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.loading_module = false;
        this.list_module = res.data.data || [];
        this.getFeaturedModule();
      });
    },

    getFeaturedModule() {
      const url = 'https://gateway.jojonomic.com/v2/lowcodeapp/14/officeless-docs/documentation/get-featured-module';
      const token = Vue.ls.get('Token');

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Apikey: 'fe63da93-60e7-4b42-b01b-e0b4c5abab47',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.loading_featured = false;
        this.list_featured = res.data.data || [];
      });
    },

    openDetailModule(module) {
      this.isOpenDetailModule = true;
      this.moduleSelected = module;

      const url = 'https://gateway.jojonomic.com/v2/lowcodeapp/14/officeless-docs/documentation/list-by-module';
      const token = Vue.ls.get('Token');
      const param = { id_module: module.id };

      axios.post(url, param, {
        headers: {
          'Content-Type': 'application/json',
          Apikey: 'fe63da93-60e7-4b42-b01b-e0b4c5abab47',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.loading_document = false;
        this.list_document = res.data.data || [];
      });
    },

    backToModule() {
      this.isOpenDetailModule = false;
      this.moduleSelected = null;
      this.loading_document = true;
      this.list_document = [];
    },

    directToDocs(docs) {
      const url = `https://docs.officeless.studio/documentation/${this.moduleSelected.key}/${docs.key}?mod=${this.moduleSelected.id}&doc=${docs.id}`;
      window.open(url, '_blank');
    },

    directToDocsFeatured(module, docs) {
      const url = `https://docs.officeless.studio/documentation/${module.key}/${docs.key}?mod=${module.id}&doc=${docs.id}`;
      window.open(url, '_blank');
    },

    filterDocument() {
      this.isOpenSearchModule = true;
      this.loading_document_by_search = true;
      this.list_document_by_search = [];
      this.count_list_document_by_search = 0;

      const url = 'https://gateway.jojonomic.com/v2/lowcodeapp/14/officeless-docs/documentation/title-search';
      const token = Vue.ls.get('Token');
      const param = {
        filter: this.search,
        limit: 100,
        page: 1,
      };

      axios.post(url, param, {
        headers: {
          'Content-Type': 'application/json',
          Apikey: 'fe63da93-60e7-4b42-b01b-e0b4c5abab47',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.loading_document_by_search = false;
        this.list_document_by_search = res.data.data || [];
        this.count_list_document_by_search = res.data.count || 0;
      });
    },

    decodeHtmlEntities(item) {
      if (item.content.blocks.length > 1) {
        if (item.content.blocks[1].data && item.content.blocks[1].data.text) {
          return he.decode(item.content.blocks[1].data.text);
        }
        return item.title;
      }
      return item.title;
    },

    directToDocsBySearch(data) {
      const keyModule = data.product_module.name.replaceAll(' ', '-');
      const urlDirect = `https://docs.officeless.studio/documentation/${keyModule}/${data.key}?mod=${data.product_module.id}&doc=${data.id}`;
      window.open(urlDirect, '_blank');
    },

    async handleLogout() {
      await this.logoutAccount();
      this.$router.push('/logout');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/jNavbar.vue